import pickBy from 'lodash-es/pickBy';

export const filterEntries = pickBy;

export const mapEntries = <K extends string, V = any>(object: Record<K, V>, predicate: (value: any) => any): any => {
    return Object.fromEntries(
        Object.entries(object).map(([key, value]) => {
            const newValue = predicate(value);

            return [key, newValue]
        })
    );
}
